// Libraries
import { Button } from '@chakra-ui/react';
// Components
import { AdjustmentsIcon } from '@atoms/index';
// Utils
import text from '@translations/en.json';
// Types
import { TableFiltersButtonProps } from './TableFiltersButton.types';

/**
 * Button component used for table filters.
 *
 * @component
 * @param {ButtonProps} props - The props for the TableFiltersButton component.
 * @param {number} props.appliedFilters - The number of applied filters.
 * @param {boolean} props.smallerViews - Flag to determine if the filters are going to be displayed in smaller views.
 * @returns {ReactElement} The TableFiltersButton component.
 */
export const TableFiltersButton = ({ appliedFilters, smallerViews = false, ...rest }: TableFiltersButtonProps) => {
  const filtersCount = appliedFilters > 0 ? `(${appliedFilters})` : '';
  const bg = appliedFilters > 0 ? 'moonraker' : 'white';
  const flex = smallerViews ? 1 : 0;
  const minW = smallerViews ? 30 : 50;
  return (
    <Button
      minW={minW}
      h={8}
      p={0}
      variant='outline'
      lineHeight={8}
      fontSize='s'
      color='text.base'
      fontWeight='medium'
      leftIcon={<AdjustmentsIcon mr={2.5} />}
      borderColor='link.base'
      bg={bg}
      flex={flex}
      {...rest}
    >
      {`${text.filters} ${filtersCount}`}
    </Button>
  );
};
